import React from 'react';
import { Drawer, DrawerContent, DrawerClose } from '@/src/components/ui/drawer';
import { IoCloseSharp } from 'react-icons/io5';
import styles from './Confirmation.module.css';
import { EXIT_TABLE_CONFIRM, LEAVE_SEAT_CONFIRM } from '@/Poker/data/Constants';
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import { useNavigate } from 'react-router';
import useActiveGames from '@/src/hooks/data/useActiveGames';

export default function Confirmation({ tempTableId, activeDrawer, open, onOpenChange }) {
    const { sendLeaveSeatProtocol, triggerExitTableFlow } = useGameSocket(tempTableId);
    const navigate = useNavigate();
    const activeGames = useActiveGames();

    const returnConfirmationTitle = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                return 'Leave Seat';
            case EXIT_TABLE_CONFIRM:
                return 'Exit Table';
            default:
                return 'Confirmation';
        }
    }

    const returnConfirmationContent = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                return 'Are you sure you want to leave your seat? It will be processed at game end.';
            case EXIT_TABLE_CONFIRM:
                return 'Are you sure you want to exit this table?';
            default:
                return 'Please confirm your action';
        }
    }

    const returnConfirmationPrimaryAction = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                return 'Leave Seat';
            case EXIT_TABLE_CONFIRM:
                return 'Exit Table';
        }
    }

    const returnConfirmationSecondaryAction = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                return 'Cancel';
            case EXIT_TABLE_CONFIRM:
                return 'Cancel';
        }
    }

    const handlePrimaryAction = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                sendLeaveSeatProtocol();
                break;
            case EXIT_TABLE_CONFIRM:
                if (activeGames.length === 1) {
                    navigate(-1, { replace: true });
                }
                triggerExitTableFlow()
                break;
        }
        onOpenChange(false);
    }

    const handleSecondaryAction = () => {
        onOpenChange(false);
    }

    const shouldShowSecondaryAction = () => {
        switch (activeDrawer) {
            case LEAVE_SEAT_CONFIRM:
                return true;
            case EXIT_TABLE_CONFIRM:
                return true;
            default:
                return false;
        }
    }

    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            <DrawerContent className={styles.container}>
                <div className={styles.drawerHeader}>
                    <DrawerClose asChild>
                        <IoCloseSharp className={styles.drawerClose} />
                    </DrawerClose>
                    <h2 className={styles.drawerTitle}>{returnConfirmationTitle()}</h2>
                </div>
                <div className={styles.drawerContent}>
                    <div className={styles.confirmationContent}>
                        <p className={styles.confirmationText}>
                            {returnConfirmationContent()}
                        </p>
                    </div>
                    <div className={styles.actionButtons}>
                        <button
                            className={styles.primaryButton}
                            onClick={handlePrimaryAction}
                        >
                            {returnConfirmationPrimaryAction()}
                        </button>
                        {shouldShowSecondaryAction() && (
                            <button
                                className={styles.secondaryButton}
                                onClick={handleSecondaryAction}
                            >
                                {returnConfirmationSecondaryAction()}
                            </button>
                        )}
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}
